export var VaniEvent;
(function (VaniEvent) {
    VaniEvent["OnInitDone"] = "onInitDone";
    VaniEvent["OnSocketError"] = "onSocketError";
    VaniEvent["OnSocketConnected"] = "onConnected";
    VaniEvent["OnSocketReconnectTimeOut"] = "onReconnectTimeOut";
    VaniEvent["OnConnected"] = "onConnected";
    VaniEvent["OnConnectionBack"] = "connectionBack";
    VaniEvent["OnMeetingStartTime"] = "meetingStartTime";
    VaniEvent["OnPermissionError"] = "permissionError";
    VaniEvent["OnPermissionApproved"] = "permissionApproved";
    VaniEvent["OnDevicesChanged"] = "onDevicesChanged";
    VaniEvent["OnTrack"] = "onTrack";
    VaniEvent["OnTrackEnded"] = "onTrackEnded";
    VaniEvent["OnUserJoined"] = "onUserJoined";
    VaniEvent["OnUserLeft"] = "onUserLeft";
    VaniEvent["OnAllParticipants"] = "participants";
    VaniEvent["OnParticipantDataUpdated"] = "onParticipantDataUpdated";
    VaniEvent["OnAudioVideoStatusUpdated"] = "audioVideoStatusUpdated";
    VaniEvent["OnNewChatMessageReceived"] = "onNewChatMessageReceived";
    VaniEvent["OnOldMessages"] = "onOldMessages";
    VaniEvent["OnSpeakerChanged"] = "onSpeakerChanged";
    VaniEvent["OnNotReachable"] = "notReachable";
    VaniEvent["OnReconectionTimeout"] = "reconectionTimeout";
    VaniEvent["OnReconecting"] = "reconecting";
})(VaniEvent || (VaniEvent = {}));
